import React from 'react';
import PropTypes from 'prop-types';

import i18n from 'i18next';
import { registerField } from 'core/forms';

import { NumberInput } from 'uikit/inputs';
import { Select } from 'uikit/selects';
import { Typo } from 'uikit/content';

import getIsDateTrigger from '../helpers/getIsDateTrigger';

import styles from '../styles/formFieldOffset.module.scss';

const INTERVALS = ['minutes', 'days', 'weeks', 'months'];

const FormFieldOffset = ({ fieldId, model = {}, updateField = () => {}, value = null }) => {
  const numberId = `${fieldId}-number`;
  const selectId = `${fieldId}-select`;
  const hasMinutes = getIsDateTrigger(model);
  const intervals = INTERVALS.filter((interval) => hasMinutes || interval !== 'minutes');
  const amountValue = value?.amount;
  const intervalValue = value?.time_interval;

  const options = intervals.map((interval) => ({
    label: i18n.t(interval.slice(0, -1), { count: amountValue ?? 0 }),
    value: interval,
  }));

  return (
    <div className={styles.element}>
      <div className={styles.field}>
        <label htmlFor={numberId}>
          <Typo variant="s02" weight="medium">
            {i18n.t('amount')}
          </Typo>
        </label>
        <NumberInput
          className={styles.number}
          id={numberId}
          minValue={0}
          onChange={(input) => updateField({ ...value, amount: input })}
          value={amountValue}
        />
      </div>
      <div className={styles.field}>
        <label htmlFor={selectId}>
          <Typo variant="s02" weight="medium">
            {i18n.t('time-interval')}
          </Typo>
        </label>
        <Select
          className={styles.select}
          id={selectId}
          onChange={(option) => updateField({ ...value, time_interval: option.value })}
          options={options}
          value={options.find((option) => option.value === intervalValue)}
        />
      </div>
    </div>
  );
};

FormFieldOffset.propTypes = {
  fieldId: PropTypes.string.isRequired,
  model: PropTypes.shape({}),
  updateField: PropTypes.func,
  value: PropTypes.shape({
    amount: PropTypes.number,
    time_interval: PropTypes.oneOf(INTERVALS),
  }),
};

registerField('Offset', FormFieldOffset);

export default FormFieldOffset;
